import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "../src/store/reducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import Home from "./pages/Home/Home";
import Shop from "./pages/Shop/Shop";
import About from "./pages/About/About";
import Product from "./pages/Product/Product";
import Contact from "./pages/Contact/Contact";
import Checkout from "./pages/Checkout/Checkout";
import PaymentInfoPage from "./pages/Payment/PaymentInfoPage";
import TermsConditions from "./pages/TermsConditions/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";

const root = ReactDOM.createRoot(document.getElementById("root"));

const persistConfig = {
  key: "main-root",
  storage,
};

// Pass through the redux devtools extension
const withDevTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, withDevTools(applyMiddleware()));
const Persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={Persistor}>
      <HelmetProvider>
        <ToastContainer
          position="top-right"
          // closeButton={CloseButton}
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          toastStyle={{
            backgroundColor: "#353A40",
            color: "white",
            fontFamily: "Jeko-Medium",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "1rem",
            lineHeight: "1.5rem",
            boxShadow: "0px 4px 10px rgba(14, 16, 17, 0.3)",
          }}
        />
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/index" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/category/*" element={<Category />} /> */}
            <Route path="/product/*" element={<Product />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment" element={<PaymentInfoPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/term-and-conditions" element={<TermsConditions />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
